<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 640 640" aria-hidden="true">
        <!-- Icon from Font Awesome Brands by Dave Gandy - https://creativecommons.org/licenses/by/4.0/ -->
        <path fill="currentColor"
            d="M160 96c-35.3 0-64 28.7-64 64v320c0 35.3 28.7 64 64 64h98.2V398.2h-52.8V320h52.8v-33.7c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V236c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V320h83.6l-14.4 78.2H351V544h129c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64z" />
    </svg>
</template>

<script>
export default {
    name: 'SquareFacebookIcon',
    props: {
        width: {
            type: [String, Number],
            default: '1em'
        },
        height: {
            type: [String, Number],
            default: null
        }
    }
};
</script>
